<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Список обучающихся</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-dropdown variant="success" v-if="isAdmin()">
          <template #button-content>
            Действие
            <b-icon-caret-down/>
          </template>
          <b-dropdown-item @click="onClickImport()">
            Импортировать обучающихся
          </b-dropdown-item>
          <b-dropdown-item @click="onClickUpdateDifferentiatedGrant()">
            Обновить значение поля 'Дифференцированный грант'
          </b-dropdown-item>
          <b-dropdown-item @click="onClickDeleteStudents()">
            Удалить обучающихся и все их данные по ИИН
          </b-dropdown-item>
          <b-dropdown-item @click="onClickDownloadTemplate()">
            Выгрузить шаблон для импорта обучающихся
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="filters">
        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="iin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по ИИН"
                       id="iin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isAdmin() || isManagerFC()">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheYear" class="form-label col-md-3">
                Год
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheYear" id="trancheYear"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(year, index) in trancheYears" :key="index" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="trancheNumber" class="form-label col-md-3">
                Номер транша
              </label>
              <div class="col-md-9">
                <select v-model="page.filter.trancheNumber" id="trancheNumber"
                        v-on:change="reloadList()"
                        class="form-select">
                  <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
                    {{ trancheNumber }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="university" class="form-label col-md-3">
                ВУЗ
              </label>
              <div class="col-md-9">
                <multiselect
                    v-model="page.filter.university"
                    :options="universities"
                    :searchable="true"
                    :closeOnSelect="true"
                    label="nameRu"
                    track-by="universityId"
                    :close-on-select="true"
                    :allow-empty="true"
                    placeholder="Выберите ВУЗ"
                    :multiple="false"
                    :clear-on-select="true"
                    @select="val => {
                      page.filter.universityId = val?.universityId || null;
                      reloadList();
                    }"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="degree" class="form-label col-md-3">
              Академическая степень
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.degreeId" id="degree"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="degree in degrees" :key="degree.id"
                        :value="degree.id">
                  {{ degree.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="profession" class="form-label col-md-3">
              Специальность
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.profession"
                  :options="professions"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="professionCustomLabel"
                  track-by="code"
                  :close-on-select="true"
                  :allow-empty="true"
                  placeholder="Выберите Специальность"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="val => {
                      page.filter.professionCode = val?.code || null;
                      reloadList();
                    }"
              />
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="courses" class="form-label col-md-3">
              Курс
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.course" id="courses"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="(course, index) in courses" :key="index" :value="course">
                  {{ course }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="paymentForm" class="form-label col-md-3">
              Форма оплаты
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.paymentFormId" id="paymentForm"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="paymentForm in paymentForms" :key="paymentForm.id" :value="paymentForm.id">
                  {{ paymentForm.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="scholarshipProgramId" class="form-label col-md-3">
              Стипендиальная программа
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.scholarshipProgramId" id="scholarshipProgramId"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="scholarshipProgram in scholarshipPrograms" :key="scholarshipProgram.id"
                        :value="scholarshipProgram.id">
                  {{ scholarshipProgram.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="differentiatedGrant" class="form-label col-md-3">
              Дифференцированный грант
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.differentiatedGrant" id="differentiatedGrant"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="transferredFromRegionalToNationalHEI" class="form-label col-md-3">
              Перевод с регионального ОВПО в национальный ОВПО
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.transferredFromRegionalToNationalHEI" id="transferredFromRegionalToNationalHEI"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="isFirstCourse" class="form-label col-md-3">
              1 курс (новый прием)
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.isFirstCourse" id="isFirstCourse"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label for="deducted" class="form-label col-md-3">
              Отчислен
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.deducted" id="deducted"
                      v-on:change="reloadList()"
                      class="form-select">
                <option :value="null">Все</option>
                <option v-for="option in yesNoList" :key="option.id"
                        :value="option.id">
                  {{ option.nameRu }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-3">
              Дата зачисление
            </label>
            <div class="row col-md-9">
              <div class="col-md-6">
                <div class="el-input-group">
                  <label for="enrollOrderStartDate" class="form-label col-md-2">
                    с
                  </label>
                  <div class="col-md-7">
                    <input
                        id="enrollOrderStartDate"
                        type="date"
                        v-model="page.filter.enrollOrderStartDate"
                        v-on:change="reloadList()"
                        class="form-control"/>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="el-input-group">
                  <label for="enrollOrderEndDate" class="form-label col-md-2">
                    до
                  </label>
                  <div class="col-md-7">
                    <input
                        id="enrollOrderEndDate"
                        type="date"
                        v-model="page.filter.enrollOrderEndDate"
                        v-on:change="reloadList()"
                        class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-9">
          <div class="el-input-group">
            <label class="form-label col-md-3">
              Дата отчисления
            </label>
            <div class="row col-md-9">
              <div class="col-md-6">
                <div class="el-input-group">
                  <label for="deductOrderStartDate" class="form-label col-md-2">
                    с
                  </label>
                  <div class="col-md-7">
                    <input
                        id="deductOrderStartDate"
                        type="date"
                        v-model="page.filter.deductOrderStartDate"
                        v-on:change="reloadList()"
                        class="form-control"/>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="el-input-group">
                  <label for="deductOrderEndDate" class="form-label col-md-2">
                    до
                  </label>
                  <div class="col-md-7">
                    <input
                        id="deductOrderEndDate"
                        type="date"
                        v-model="page.filter.deductOrderEndDate"
                        v-on:change="reloadList()"
                        class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                v-if="isManagerFC() || isUniversityManager() || isAdmin()"
                :disabled="items.length === 0"
                @click="onClickExportStudents()">
        Экспортировать в MS Excel
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(studentId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('studentId')"
             :class="{'ascending': page.sort.studentId === 'ASC', 'descending': page.sort.studentId === 'DESC'}">
          studentId
        </div>
      </template>
      <template #head(iin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('iin')"
             :class="{'ascending': page.sort.iin === 'ASC', 'descending': page.sort.iin === 'DESC'}">
          ИИН
        </div>
      </template>
      <template #head(lastname)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lastname')"
             :class="{'ascending': page.sort.lastname === 'ASC', 'descending': page.sort.lastname === 'DESC'}">
          Фамилия
        </div>
      </template>
      <template #head(firstname)="data">
        <div class="sortable-container none"
             @click="onSortChanged('firstname')"
             :class="{'ascending': page.sort.firstname === 'ASC', 'descending': page.sort.firstname === 'DESC'}">
          Имя
        </div>
      </template>
      <template #head(patronymic)="data">
        <div class="sortable-container none"
             @click="onSortChanged('patronymic')"
             :class="{'ascending': page.sort.patronymic === 'ASC', 'descending': page.sort.patronymic === 'DESC'}">
          Отчество
        </div>
      </template>
      <template #head(universityName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('universityName')"
             :class="{'ascending': page.sort.universityName === 'ASC', 'descending': page.sort.universityName === 'DESC'}">
          ВУЗ
        </div>
      </template>
      <template #head(actions)="data" v-if="canRemove()">
      </template>

      <template #cell(studentId)="data">
        {{ data.item.studentId }}
      </template>
      <template #cell(iin)="data">
        {{ data.item.iin }}
      </template>
      <template #cell(lastname)="data">
        <div v-if="canOpenProfile()">
          <a :href="`/students/${data.item.uuid}`">
            {{ data.item.lastname }}
          </a>
        </div>
        <div v-else>
          {{ data.item.lastname }}
        </div>
      </template>
      <template #cell(firstname)="data">
        <div v-if="canOpenProfile()">
          <a :href="`/students/${data.item.uuid}`">
            {{ data.item.firstname }}
          </a>
        </div>
        <div v-else>
          {{ data.item.firstname }}
        </div>
      </template>
      <template #cell(patronymic)="data">
        <div v-if="canOpenProfile()">
          <a :href="`/students/${data.item.uuid}`">
            {{ data.item.patronymic }}
          </a>
        </div>
        <div v-else>
          {{ data.item.patronymic }}
        </div>
      </template>
      <template #cell(universityName)="data">
        {{ data.item.universityName }}
      </template>
      <template #cell(actions)="data" v-if="canRemove()">
        <div class="action-cell">
          <b-button class="btn btn-danger btn-sm delete-button"
                    @click="onClickRemove(data.item)">
            Удалить
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Импорт обучающихся" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="trancheYear" class="form-label">
          Год
        </label>
        <select v-model="dialog.filter.trancheYear" id="trancheYear" required
                class="form-select">
          <option v-for="(year, index) in trancheYears" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheNumber" class="form-label">
          Номер транша
        </label>
        <select v-model="dialog.filter.trancheNumber" id="trancheNumber"
                class="form-select" required>
          <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
            {{ trancheNumber }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="fileUpload" class="form-label">
          Файл с данными (*.csv)
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input type="file" id="fileUpload" @change="handleFileUpload" accept=".csv" class="form-control"/>
        </div>
      </div>
    </form>
  </b-modal>

  <b-modal v-model="showActionModal" :title="actionDialogTitle" @ok="onSubmitAction">
    <form class="mb-4">
      <div class="mb-3">
        <label for="fileUpload" class="form-label">
          Файл с данными (*.csv)
          <span class="text-danger">*</span>
        </label>
        <div class="col-md-9">
          <input type="file" id="fileUpload" @change="handleFileUpload" accept=".csv" class="form-control"/>
        </div>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import studentService from "@/services/studentService";
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import universityService from "@/services/universityService";
import degreeService from "@/services/degreeService";
import professionService from "@/services/professionService";
import settingsService from "@/services/settingsService";
import authService from "@/services/authService";
import delegationService from "@/services/delegationService";
import xlsExportService from "@/services/xlsExportService";
import {TemplateTypeEnum} from "@/enum/TemplateTypeEnum";
import {saveAs} from "@/assets/FileSaver.min";
import scholarshipProgramService from "@/services/scholarshipProgramService";
import paymentFormService from "@/services/paymentFormService";
import {StudentDataActionTypeEnum} from "@/enum/StudentDataActionTypeEnum";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      showActionModal: false,
      uploadedFile: null,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      page: {
        filter: {
          search: null,
          trancheYear: null,
          trancheNumber: null,
          universityId: null,
          degreeId: null,
          professionCode: null,
          paymentFormId: null,
          course: null,
          deducted: null,
          scholarshipProgramId: null,
          differentiatedGrant: null,
          transferredFromRegionalToNationalHEI: null,
          enrollOrderStartDate: null,
          enrollOrderEndDate: null,
          deductOrderStartDate: null,
          deductOrderEndDate: null,
          isFirstCourse: null,
        },
        sort: {
          iin: null,
          firstname: null,
          lastname: null,
          patronymic: null
        },
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      fields: [
        {key: 'studentId', label: 'studentId', sortable: true},
        {key: 'iin', label: 'ИИН', sortable: true},
        {key: 'lastname', label: 'Фамилия', sortable: true},
        {key: 'firstname', label: 'Имя', sortable: true},
        {key: 'patronymic', label: 'Отчество', sortable: true},
        {key: 'universityName', label: 'ВУЗ', sortable: true },
        {key: 'actions', label: '', sortable: false}
      ],
      items: [],
      universities: [],
      degrees: [],
      professions: [],
      scholarshipPrograms: [],
      paymentForms: [],
      courses: Array.from({length: 10}, (v, i) => 1 + i),
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      dialog: {
        filter: {
          trancheYear: null,
          trancheNumber: null
        }
      },
      actionType: null,
      actionDialogTitle: null,
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i),
      adminRoles: authService.getAdminRoles(),
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles()
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.page.filter.trancheYear = this.setting.defaultTrancheYear;
        this.page.filter.trancheNumber = this.setting.defaultTrancheNumber;

        this.reloadList();
      });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    async reloadList() {
      this.isLoading = true;
      const response = await studentService.getAll(this.page);
      this.items = response.list;
      this.totalCount = response.count;
      this.isLoading = false;
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };
      this.reloadList();
    },
    async submitForm() {
      if (!this.uploadedFile) {
        showErrorNotify("Убедитесь, что все обязательные поля заполнены");
        return;
      }

      this.isLoading = true;

      try {
        const formData = new FormData();
        formData.append('file', this.uploadedFile);
        formData.append('trancheYear', this.dialog.filter.trancheYear);
        formData.append('trancheNumber', this.dialog.filter.trancheNumber);

        await studentService.uploadStudentsCsv(formData);

        this.reloadList();

        showSuccessNotify("Файл успешно загружен");
        this.showModal = false;
      } catch (error) {
        showErrorNotify(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onClickRemove(item) {
      const confirmed = await confirm("Вы уверены, что хотите удалить этот элемент?");
      if (confirmed) {
        try {
          await studentService.deleteById(item.uuid);

          this.reloadList();

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    async onClickImport() {
      this.uploadedFile = null;

      this.dialog.filter.trancheYear = this.setting.defaultTrancheYear;
      this.dialog.filter.trancheNumber = this.setting.defaultTrancheNumber;

      this.showModal = true;
    },
    async onClickDeleteStudents() {
      const confirmed = await confirm("Вы действительно хотите удалить обучающихся?");
      if (confirmed) {
        this.uploadedFile = null;
        this.actionDialogTitle = "Удаление обучающихся( год: " + this.setting.defaultTrancheYear + ", транш: " + this.setting.defaultTrancheNumber + ")";
        this.actionType = StudentDataActionTypeEnum.DELETE_STUDENTS;
        this.showActionModal = true;
      }
    },
    async onClickUpdateDifferentiatedGrant() {
      const confirmed = await confirm("Вы действительно хотите обновить данные?");
      if (confirmed) {
        this.uploadedFile = null;
        this.actionDialogTitle = "Обновить значение поля 'Дифференцированный грант'";
        this.actionType = StudentDataActionTypeEnum.UPDATE_DIFFERENTIATED_GRANT;
        this.showActionModal = true;
      }
    },
    async onClickDownloadTemplate() {
      await this.downloadCsv(TemplateTypeEnum.STUDENTS_TEMPLATE_CSV);

    },
    async downloadCsv(templateType) {
      this.isLoading = true;
      const response = await xlsExportService.exportStudents(templateType, this.page);
      const blob = new Blob([response], {type: "text/csv"});
      saveAs(blob, "student-import-template.csv");
      this.isLoading = false;
    },
    async onSubmitAction() {
      if (!this.uploadedFile) {
        showErrorNotify("Выберите файл в формате *.csv");
        return;
      }

      if (this.actionType == null) {
        return;
      }

      this.isLoading = true;

      try {
        this.dialog.filter.trancheYear = this.setting.defaultTrancheYear;
        this.dialog.filter.trancheNumber = this.setting.defaultTrancheNumber;

        const formData = new FormData();
        formData.append('file', this.uploadedFile);
        formData.append('trancheYear', this.dialog.filter.trancheYear);
        formData.append('trancheNumber', this.dialog.filter.trancheNumber);
        formData.append('actionType', this.actionType.code);

        await studentService.processStudentsCsv(formData);

        this.reloadList();

        showSuccessNotify("Успешно выполнено");
        this.showActionModal = false;
      } catch (error) {
        console.error(error);
        showErrorNotify(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onClickExportStudents() {
      this.isLoading = true;
      const response = await xlsExportService.exportStudents(TemplateTypeEnum.STUDENTS_XLSX, this.page);
      const blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      saveAs(blob, "document.xlsx");
      this.isLoading = false;
    },
    canOpenProfile() {
      return this.isAdmin() || this.isUniversityManager() || this.isManagerFC() || delegationService.isAdminReadOnly();
    },
    canRemove() {
      return this.isAdmin();
    },

    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
    initUniversities() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };
      universityService.getAll(params)
          .then(response => {
            this.universities = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initDegrees() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };

      degreeService.getAll(params)
          .then(response => {
            this.degrees = response.list.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initProfessions() {
      const params = {
        partNumber: 1,
        countInPage: 0,
        filter: {}
      };

      professionService.getAll(params)
          .then(response => {
            this.professions = response.list.sort((a, b) => a.code.localeCompare(b.code));
          });
    },
    initScholarshipPrograms() {
      scholarshipProgramService.getAll()
          .then(response => {
            this.scholarshipPrograms = response.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    initPaymentForms() {
      paymentFormService.getAll()
          .then(response => {
            this.paymentForms = response.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    professionCustomLabel(option) {
      return `${option.code} ${option.nameRu}`
    },
  },
  mounted() {
    this.initUniversities();
    this.initDegrees();
    this.initProfessions();
    this.initScholarshipPrograms();
    this.initPaymentForms();

    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
